import React, { useState, useRef } from 'react';
import { Button, Col, Modal, Form, Input, Row, Space, message, Card } from 'antd';
import { getEmpleadoById, updateById } from '../../../../apis/OdooApi';

const ChangePassword = ({ id, open = false, finish, inline = false }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');

    const handleOk = async () => {
        try {
            const fields = await form.validateFields();
            setLoading(true);
            
            // Primero obtenemos los datos actuales del empleado para enviar campos requeridos
            const empleadoResponse = await getEmpleadoById(id);
            
            if (!empleadoResponse.ok) {
                message.error('Error al obtener los datos del empleado');
                return;
            }
            
            const payload = {
                id: id,
                periodo_id: empleadoResponse.payload.periodo_id,
                analitica_id: empleadoResponse.payload.analitica_id,
                password: fields.new_password,
            };
            
            const response = await updateById(payload);
            
            if (response.ok) {
                message.success('Contraseña actualizada correctamente!');
                form.resetFields();
                finish(true);
            } else {
                message.error('Error al actualizar la contraseña');
            }
        } catch (errorInfo) {
            message.error('Por favor completa todos los campos obligatorios.');
        } finally {
            setLoading(false);
        }
    };

    const onClose = () => {
        form.resetFields();
        finish(false);
    };

    const effectRan = useRef(false);
    React.useEffect(() => {
        const shouldRun = (inline || open) && id > 0;
        if (!effectRan.current && shouldRun) {
            (async () => {
                const response = await getEmpleadoById(id);
                if (response.ok) {
                    setCurrentPassword(response.payload.password || '');
                }
            })();
        }
        return () => (effectRan.current = true);
    }, [id, open, inline]);

    const formContent = (
        <Form
            layout="vertical"
            form={form}
            requiredMark
        >
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        name="new_password"
                        label="Nueva Contraseña"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor ingrese la nueva contraseña',
                            },
                            {
                                min: 6,
                                message: 'La contraseña debe tener al menos 6 caracteres',
                            },
                        ]}
                        hasFeedback
                    >
                        <Input.Password
                            placeholder="Ingrese nueva contraseña"
                            visibilityToggle
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="confirm_password"
                        label="Confirmar Nueva Contraseña"
                        dependencies={["new_password"]}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Por favor confirme la contraseña',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('new_password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Las contraseñas no coinciden'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            placeholder="Confirme la nueva contraseña"
                            visibilityToggle
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );

    if (inline) {
        return (
            <Card title="Cambiar Contraseña">
                {formContent}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button type="primary" loading={loading} onClick={handleOk}>Guardar</Button>
                </div>
            </Card>
        );
    }

    return (
        <Modal
            title="Cambiar Contraseña"
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="back" onClick={onClose}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Guardar
                </Button>,
            ]}
            width={500}
        >
            {formContent}
        </Modal>
    );
};

export default ChangePassword;
